import { WebViewerOptions } from '@pdftron/webviewer';
import { PDFTRON_KEY } from 'config/environment';

export const getWebviewerConfig = (
  config: Partial<WebViewerOptions>,
): WebViewerOptions => ({
  ...config,
  css: '/pdftron.css',
  path: '/webviewer',
  fullAPI: true,
  disabledElements: [
    'header',
    'ribbons',
    'notesPanel',
    'annotationStyleEditButton',
    'annotationGroupButton',
    'freeHandHighlightToolButton',
    'linkButton',
    'annotationPopup',
    'contextMenuPopup',
    'panToolButton',
    'calloutCreateTool',
    'eraserTool',
    'freeHandTool',
    'stampTool',
    'lineCreateTool',
    'ellipseCreateTool',
    'toolsHeader',
  ],
  autoFocusNoteOnAnnotationSelection: true,
  loadAsPDF: true,
  licenseKey: PDFTRON_KEY,
});
